// removed by extract-text-webpack-plugin
module.exports = {"standardHeader":"yexXBMf","dividerHeader":"_3bUjJb_"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/TieredSearchResultList/components/Tier/Tier.less
 ** module id = 824
 ** module chunks = 0
 **/